// @flow
import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import {
  passwordValidation,
  passwordConfirm
} from '../../utilities/validations';
import Input from '../../components/Input';
import SubmitButton from '../../components/SubmitButton';
import { setSignInMessage } from '../SignIn/reducer';
import { history } from '../../utilities/history';
import { GreyTextReactLink } from '../../components/LinkStyles';

type Props = {
  handleSubmit: (values: any) => void,
  error: ?string,
  submitting: boolean
};

class UpdatePassword extends Component<Props> {
  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <h1>Reset Password</h1>
        <Field
          name="password"
          label="Password (min 8 characters)"
          validate={passwordValidation}
          type="password"
          component={Input}
          passwordValidation
        />
        <Field
          name="password_confirmation"
          label="Confirm Password"
          validate={passwordConfirm}
          type="password"
          component={Input}
        />

        <SubmitButton
          value="Submit"
          error={this.props.error}
          disabled={this.props.submitting}
          marginTop="3rem"
        />
        <GreyTextReactLink to="/signin">Cancel</GreyTextReactLink>
      </form>
    );
  }
}

const onSubmitSuccess = (result, dispatch) => {
  history.push('/signin');
  dispatch(setSignInMessage('Password reset, please sign in to continue'));
};

export default reduxForm({
  form: 'updatePassword',
  onSubmitSuccess
})(UpdatePassword);
